import React, { useState, Fragment, useEffect } from 'react';
import {
    Row, Button, Card,
    CardBody, CustomInput,
    FormGroup,
    Label,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup
} from "reactstrap";
import { Colxx } from "../../../../../components/common/CustomBootstrap";

export default function AiVoiceChannel({
    templateData,
    updateTemplateData,
    assistantList,
    clickAiEmail,
    submit,
    isSuccess,
}) {
    return (
        <div className="mb-4 ml-4">
            <Row>

                {/* ---------- AI VOICE ENABLED ---------- */}
                <Colxx sm={12} className="mb-2">
                    <h5>AI Voice Channel</h5>

                    <FormGroup>
                        <CustomInput
                            type="checkbox"
                            id="isAiVoice"
                            checked={true}
                            disabled={true}
                            label="AI Voice"
                        />
                    </FormGroup>
                </Colxx>

                {/* ---------- DYNAMIC FLOW ---------- */}
                {assistantList && assistantList.length > 0 && (
                    <Colxx xxs="12" className="mb-2">
                        <Label style={{ fontSize: "14px" }}>Dynamic Conversation Flow</Label>

                        <Input
                            className="w-40"
                            type="select"
                            value={templateData.dynamicFlowId || ""}
                            onChange={(e) =>
                                updateTemplateData("dynamicFlowId", e.target.value || null)
                            }
                        >
                            <option value="">Select a Dynamic Conversation Flow</option>


                            {assistantList.map((assist, index) => (
                                <option key={index} value={assist.openAiAssistantId}>
                                    {assist.name} ({assist.openAiAssistantId})
                                </option>
                            ))}
                        </Input>
                    </Colxx>
                )}

                <Colxx xxs="12" className="mb-4 mt-4 text-right">
                    {isSuccess ?
                        <Button
                            color="primary"
                            size="lg"
                            outline
                            className=" mr-1"
                            onClick={clickAiEmail}
                        >
                            Next
                        </Button>
                        :
                        <div>
                            <Button
                                color="secondary"
                                size="lg"
                                outline
                                className="mr-2"
                                onClick={clickAiEmail}
                            >
                                Skip
                            </Button>

                            <Button
                                color="primary"
                                size="lg"
                                outline
                                className="mr-1"
                                onClick={submit}
                            >
                                Create AI Voice Channel
                            </Button>
                        </div>
                    }
                </Colxx>
            </Row>
        </div>
    );
}